import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/webxr',
    name: 'webxr',
    component: () => import('@/views/WebXR/WebXR.vue')

  }
]

const router = new VueRouter({
  routes
})

export default router
